import { render, staticRenderFns } from "./AccessServiceAdd.vue?vue&type=template&id=367ec868&scoped=true"
import script from "./AccessServiceAdd.vue?vue&type=script&lang=ts"
export * from "./AccessServiceAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ec868",
  null
  
)

export default component.exports